import React from 'react';
import { getResizedMediaUrl, defaultLogoImageUrl } from '../../services/APIClient';

const HomepageBrands = ({
  brands,
}) => {
  let value = null;

  value = (
    <div className="pt-l">
      <div className="row align-center pb-l">
        <div className="column">
          <h4>Featured Manufacturers</h4>
        </div>
      </div>
      {/* Brand Cards */}
      <div className="row align-center" style={{ maxWidth: '1440px' }}>
        <div className="column">
          <div className="row small-up-1 medium-up-2 large-up-4" >
            {/* Brand Card */}
            {brands.map((brand) => {
              const heroUrl = brand.hero.length ? brand.hero[0].mediaItem.url : defaultLogoImageUrl;
              let logoUrl = brand.logo.length ? brand.logo[0].mediaItem.url : defaultLogoImageUrl;
              logoUrl = logoUrl === defaultLogoImageUrl ? logoUrl
                : getResizedMediaUrl(logoUrl, 40, 40);
              return (
                <a
                  className="column"
                  key={brand.name}
                  href={`/brands/${brand.slug}`}
                >
                  <div className="card hover">
                    {/* Image */}
                    <div className="card-section">
                      <div
                        className="card-image card-image-no-margin hide-for-large"
                        style={{ height: '160px', backgroundImage: `url(${heroUrl})` }}
                      />
                      <div
                        className="card-image card-image-no-margin show-for-large"
                        style={{ backgroundImage: `url(${heroUrl})` }}
                      />
                    </div>
                    {/* Info */}
                    <div className="card-section">
                      <div className="row align-middle mt-s">
                        <div className="columns shrink mr-base">
                          <img style={{ height: '40px' }} src={logoUrl} alt="Logo" />
                        </div>
                        <div className="columns">
                          <h4 className="ellipsis">{brand.name}</h4>
                          <p className="mb-0 ellipsis">{brand.projectsWithPlacementsCount} Projects</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              );
            },
            )}
          </div>
        </div>
      </div>
    </div>
  );
  return value;
};

export default HomepageBrands;



// WEBPACK FOOTER //
// ./js/src/components/homepage/HomepageBrands.jsx